<template>
  <div class="main">
    <div class="list">
    	<div class="l-title">头像</div>
    	<div class="l-list">
    		<img class="l-img" :src="$avatarHash($store.state.mineInfo.id)" @click="set_icon = true">
    		<el-button class="l-img-btn" @click="set_icon = true">更换头像</el-button>
    	</div>
    </div>
    <div class="list">
    	<div class="l-title">用户名</div>
    	<div class="l-list">
    		<el-input class="l-input" v-model.trim="name" @keyup.native="trimLR"></el-input>
    		<el-button class="l-img-btn" @click="saveUserName(name)">保存</el-button>
    	</div>
    </div>
    <div class="list">
    	<div class="l-title">手机账号</div>
    	<div class="l-list">
    		<!-- <el-input class="l-input" v-model="phone"></el-input> -->
    		<div>{{phone}}</div>
    		<el-button class="l-img-btn" @click="ammedPhoneDialog = true">修改手机号</el-button>
    		<el-button class="l-pass-btn" @click="to_change_pw">设置/修改密码</el-button>
    	</div>
    </div>
    <div class="list">
    	<div class="l-title">微信绑定</div>
    	<div class="l-list">
    		<img class="l-img" :src="bindstatus.wexin_avatar" v-if="bindstatus._weixin">
    		<el-button class="l-img-btn" v-if="bindstatus._weixin" @click="unbindwchat">解除绑定</el-button>
    		<el-button class="l-img-btn" v-else @click="bindQQandWX('weixinweb')">绑定微信</el-button>
    	</div>
    </div>


	<!-- 更换头像 -->
    <Modal
        v-model="set_icon"
        :mask-closable="false"
        width="725"
        class-name="user-icon-model">
        <Row class="wrap">
            <Col span="24" class="main">
                <imgUpload field="avatar"
                    @upload-success="imguploadsuccess"
                    :width="170"
                    :height="170"
                    :showAvatarUrl="avatarImg"
                    :url="'/userinfo/setavatar'"
                    img-format="png">
                </imgUpload>
            </Col>
        </Row>
        <div slot="footer"></div>
    </Modal>

    <!-- 修改手机 -->
    <Modal
        v-model="ammedPhoneDialog"
        :mask-closable="false"
        width="425"
        class-name="set_pw_modal"
        @on-cancel="cancel"
    >
        <div class="modal_title">修改手机</div>


        <div v-if="verifyPhoneType === 'phone'" class="set_pw_main">
            <Input placeholder="输入当前密码" type="password" v-model="verifyPhonePWD" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"></Input>
            <div style="marginTop: 20px"></div>
            <Button long type="primary" @click="verifypassword" >确 定</Button>
        </div>
        <div class="set_pw_main" v-else>
            <Form
                :model="verifyPhoneForm"
                :rules="verifyPhoneFormRule"
                ref="verifyPhoneForm"
            >
                <FormItem prop="phone">
                    <Input placeholder="新手机号" v-model.trim="verifyPhoneForm.phone" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"></Input>
                </FormItem>

                <Row :gutter="16">
                    <Col :span="14">
                        <FormItem prop="code">
                            <Input placeholder="验证码" v-model.trim="verifyPhoneForm.code" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"></Input>
                        </FormItem>
                    </Col>

                    <Col :span="10">
                        <FormItem style="text-align:right">
                            <!-- <Button>获取验证码</Button> -->
                            <Button @click="getcode('verifyPhoneForm')" type="ghost" :disabled="!!verifyPhoneForm.runtime" style="width: 87px; height: 35px; padding: 0;">{{!!verifyPhoneForm.runtime ? `${verifyPhoneForm.runtime} 秒后重发` : '获取验证码'}}</Button>
                        </FormItem>
                    </Col>
                </Row>

                <FormItem>
                    <Row :gutter="16">
                        <Col span="24">
                            <Button long type="primary" @click="verifyPhoneFn('verifyPhoneForm')">确 定</Button>
                        </Col>
                    </Row>
                </FormItem>
            </Form>
        </div>


        <div slot="footer"></div>
        
    </Modal>


    <!-- 设置密码modal -->
    <!-- :closable="false" -->
    <Modal
        v-model="set_pw_Modal"
        
        :mask-closable="false"
        width="425"
        class-name="set_pw_modal">
        <!-- <div class="modal_tit">{{set_pw_text}}</div> -->
        <div class="modal_title">修改密码</div>
        <div class="set_pw_main">
             <Form v-if="set_pw_Modal" :model="form_set_pw" ref="form_set_pw" :rules="rule_form_set_pw">
                <!-- 绑定输入账号的显示 -->
                <FormItem style="margin-bottom: 15px" prop="pw00" v-if="is_change_pw">
                    <Input v-model.trim="form_set_pw.pw00" type="password" placeholder="原密码" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"></Input>
                </FormItem>
                <FormItem style="margin-bottom: 15px" prop="pw01">
                    <Input v-model.trim="form_set_pw.pw01" type="password" placeholder="新密码" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"></Input>
                </FormItem>
                <FormItem style="margin-bottom: 15px" prop="pw02">
                    <Input v-model.trim="form_set_pw.pw02" type="password" placeholder="确认密码" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"></Input>
                </FormItem>
                <FormItem style="margin-bottom: 5px">
                    <Row :gutter="16">
                        <Col span="24">
                            <Button long type="primary" @click="submit_pw('form_set_pw')">确 定</Button>
                        </Col>
                        <!-- <Col span="12">
                            <Button class="gray_btn" long type="primary" @click="give_up_pw">放 弃</Button>
                        </Col> -->
                    </Row>
                </FormItem>
            </Form>
        </div>
        <div slot="footer"></div>
    </Modal>

  </div>
</template>

<script>
// 这里引用 _1 是为了不改变 imgUpload 组件在其他页面样式
import imgUpload from './imgUpload_1';
export default {
  	name: 'AccountSet',
  	components: {
        imgUpload
    },
  	data () {
    	return {
      		name:this.$store.state.mineInfo.name,
      		phone:this.$store.state.mineInfo.phone,
      		set_icon:false, // 设置头像
      		bindstatus:{},  //账号信息
            form_bind: {
                bund_number: '',
                code: '',
            },
            // 修改手机弹窗
            ammedPhoneDialog: false,
            verifyPhoneType: 'phone',
            verifyPhonePWD: '',
            verifyPhoneForm: {
                phone: '',
                code: '',
                runtime: 0,
                againtime: 60
            },
            verifyPhoneFormRule: {
                phone: [
                    { validator: (rule, value, callback) => {
                        if (value === '') {
                            callback(new Error('手机号不能为空'));
                        } else if( /^1[0-9]{10}$/.test(value) ){
                            callback();
                        }else{
                            callback(new Error('请输入正确的手机号'));
                        }
                    }, trigger: 'blur' },
                ],
                code: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                ],
            },

            show_bind_input: false,  /*1--已绑定账号的显示 2--还没绑定账号，输入账号、验证码的显示*/
            /* 设置密码 */
            set_pw_Modal: false,
            is_change_pw: false,
            show_code_input: false,
            form_set_pw: {
                pw00: '',
                pw01: '',
                pw02: ''
            },

            // 设置密码
            
            rule_form_set_pw: {
                pw00: [
                    { validator : (rule, value, callback) => {
                        if (value.length < 6) {
                            callback(new Error('请输入六位以上的密码'));
                        }else{
                            callback();
                        }
                    }, required: false, trigger: 'change'}
                ],
                pw01: [
                    { validator : (rule, value, callback) => {
                        if (value.length < 6) {
                            callback(new Error('请输入六位以上的密码'));
                        }else{
                            callback();
                        }
                    }, required: false, trigger: 'change'}
                ],
                pw02: [
                    { validator : (rule, value, callback) => {
                        if (value.length < 6) {
                            callback(new Error('请输入六位以上的密码'));
                        } else if(value !== this.form_set_pw.pw01) {
                            callback(new Error('两次输入的密码不一致'));
                        }else{
                            callback();
                        }
                    }, required: false, trigger: 'change'}
                ]
            },
    	}
  	},
  	computed:{
  		/*显示的头像*/
    	avatarImg() {
        	return `${imgUrl}/uploads/avatar/${this.$store.state.mineInfo.id}.jpg?${this.$store.state.mineInfo.avatar_hash}`;
    	},
  	},
  	mounted(){
  		this.getBindstatus();
  	},
  	methods:{
        trimLR() {
            this.name = this.name.replace(/^\s+|\s+$/gm,'')
            //replace(/^\s+|\s+$/gm,'')去除input的空字符串
        },
        getMine() {
            let mineURL = '/userinfo/mine';
            let _this = this
            this.$http.get(mineURL).then((response) => {
                let data = response.data;
                if (data.retcode === RETCODE_OK) {
                    _this.$store.commit('changeloginStatus', true);
                    _this.$store.commit('rewriteMineInfo', data.data);
                    // sockets(data.data.id);
                }else{
                    console.log(data.errmsg);
                }
                // if(callback) callback();
            }).catch(error => {
                // if(callback) callback();
            });
        },
		imguploadsuccess(data) {
            // this.$store.commit('changeMineInfo',{ key : 'avatar_hash' , value : data.avatar_hash});
            this.$store.commit('changeMineInfo',{ 'avatar_hash' :  data.avatar_hash});
            this.set_icon = false;
        },
        //获取账号信息
        getBindstatus() {
            let URL = `/userinfo/getbind`;
            this.$http.get(URL).then((response) => {
                let data = response.data;
                if (data.retcode === RETCODE_OK) {
                    this.bindstatus = data.data;
                    if(data.data._bund){
                        /* 之前已有绑定 */
                        this.form_bind.bund_number = data.data.bund_number || '';
                        this.show_bind_input = false;
                    }else {
                        this.show_bind_input = true;
                    }
                }else {
                    this.$Message.error(data.errmsg)
                }
            }).catch(error => {
                this.$Message.error('请求有误！')
            });
        },
        to_change_pw() {
            if(this.bindstatus._pwd_set){
                this.is_change_pw = true;
            }else{
                this.is_change_pw = false;
            };
            // this.is_change_pw = true;
            this.set_pw_Modal = true;
        },
        submit_pw(name) {
            this.$refs[name].validate((valid) => {
                if (valid) {

                    let _this = this;
                    function _submit() {
                        let URL = '';
                        let param = {};
                        /* 更改密码 */
                        if (_this.is_change_pw) {
                            URL = '/useraccount/changepassword';
                            param = {
                                oldpassword: _this.form_set_pw.pw00,
                                password: _this.form_set_pw.pw01
                            };
                        } else {
                            /* 设置密码 */
                            // URL = '/userinfo/setbind';
                            URL = '/auth/setPassword';  //新的
                            param = {
                                password: _this.form_set_pw.pw01
                            };
                        }
                        _this.$http.post(URL,param).then((response) => {
                            let data = response.data;
                            if (data.retcode === RETCODE_OK) {
                                if (_this.is_change_pw) {
                                    _this.$Message.success('密码更改成功!');
                                    _this.$store.commit('clearalldata');
                                    _this.$store.commit('changebindPhone', false);
                                    _this.$router.push({name: 'home'});
                                    _this.$store.commit('changeLoginModalStatus', {display: true, type: 'login'});
                                } else {
                                    _this.bindstatus._pwd_set = true;
                                    _this.bindstatus._bund = true;
                                    _this.show_bind_input = false;
                                    _this.show_code_input = false;
                                    _this.$Message.success('密码设置成功!');
                                    _this.$store.commit('clearalldata');
                                    _this.$store.commit('changebindPhone', false);
                                    _this.$router.push({name: 'home'});
                                    _this.$store.commit('changeLoginModalStatus', {display: true, type: 'login'});
                                }
                                _this.set_pw_Modal = false;
                            }else {
                                _this.$Message.error(data.errmsg);
                            }
                        }).catch(error => {
                            console.log(error);
                        });
                    }

                    if( this.is_change_pw ){
                        this.$Modal.confirm({
                            title: '密码',
                            content: '是否更改密码?',
                            onOk: () => {
                                _submit();
                            },
                            onCancel: () => {}
                        });
                    }else{
                        _submit();
                    }
                } else {
                    // this.$Message.error('表单验证失败!');
                }
            })
        },
        give_up_pw() {
            this.$Modal.confirm({
                title: '密码',
                content: '是否放弃修改密码?',
                onOk: () => {
                    if (!this.bindstatus._pwd_set) {
                        // 第一次绑定还没有设置过密码
                        this.form_bind.bund_number = '';
                        this.form_bind.code = '';

                        this.show_code_input = false;
                    }
                    this.set_pw_Modal = false;
                }
            });
        },
        // 解除绑定微信
        unbindwchat() {
            this.$confirm('此操作将解除绑定微信, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
                let param = {}
                this.$ajax('post', '/useraccount/oauthoutbind/weixinweb', param, res => {
                    this.getBindstatus();
                    this.$message({
                        type: 'success',
                        message: '解除绑定成功!'
                      });
                })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消解除绑定！'
              });          
            });
        },
        bindQQandWX(type) {
            window.open(`${imgUrl}/useraccount/oauthbind/${type}`);
        },
        // 保存用户名
        saveUserName(value) {
        	if (!value) {
                this.$Message.error('昵称不能为空');
            }
            else if (/[@#\$%\^&\*]+/g.test(value)) {
                this.$Message.error('请勿包含非法字符');
            }
            else if (/ /.test(value)) {
                this.$Message.error('请勿包含空格');
            }
            else if (value.length > 9) {
                this.$Message.error('长度在1-9之间');
            }else if(value.substring(0,2) == '用户' && /^[0-9]+.?[0-9]*$/.test(value.substring(2,value.length)) ){
                this.$Message.error('昵称格式不正确');
            }else{
            	let option = {
	                name : this.name
	            }
	            this.$http.post('/nameverify', option).then(res => {
	                if(res.data.retcode === 0) {
	                    let param = {
	                        nickname: this.name
	                    }
	                    let url = 'userinfo/setuserinfo'

	                    this.$ajax('post', url, param, res => {
	                        this.$Message.success('修改成功');
	                        this.emitUsername = false
	                    })
	                } else {
	                    this.emitUsername = false
	                    this.$Message.error(res.data.errmsg)
	                    return false
	                }
	            })
            }
        },
        // 检验密码
        verifypassword() {
            
            if (this.verifyPhonePWD.length === 0) {
                this.$Message.error('密码不能为空')
                 return false
            }
            if (this.verifyPhonePWD.length >= 1 && this.verifyPhonePWD.length < 6) {
                this.$Message.error('密码长度最少6位')
                return false
            } 
            let param = {
                password: this.verifyPhonePWD
            }
            this.$ajax('post', 'userinfo/passwordverify', param, res => {
                this.verifyPhonePWD = ''
                this.verifyPhoneType = 'newPhone'
            })
            

            // console.log(this.verifyPhonePWD)
        },
        //获取验证码
        getcode(name) {
            if( this[name].runtime ){
                return;
            }
            let accpet;
            this.$refs[name].validateField('phone', cb => { accpet = cb });
            if( accpet != "" ){
                return false;
            }
            this.starttime(name);
            // let url = '/cs/companyaccount/sendsmscode';
            let url = 'sms/verifycode'
            let param = {phone: this[name].phone, type: 'register'};
            this.$http.post(url, param).then(response => {
                if( response.data.retcode == RETCODE_OK ){
                    this.$Message.success( '获取验证码成功，请查收!' );
                }else{
                    this[name].runtime = 0;
                    this.$Message.error( response.data.errmsg );
                }
            }).catch(err => {
                if( err.response ) {
                    switch( err.response.status ) {
                        case 429:
                            this.$Message.error( '发送验证码太频繁，请稍后重试！' );
                    }
                }
            });
        },
        starttime(name) {
            this[name].runtime = this[name].againtime;
            let setTime = () => {
                setTimeout(() => {
                    if( this[name].runtime <= 0 ){

                    }else{
                        this[name].runtime -= 1;
                        setTime();
                    }
                }, 1000);
            }
            setTime();
        },
        verifyPhoneFn(name) {
            this.$refs[name].validate((valid) => {
                if( valid ){
                    this.$ajax('post', 'userinfo/verifybind', {phone: this.verifyPhoneForm.phone, code: this.verifyPhoneForm.code}, data => {
                        // this.verifyPhoneModal = false;
                        this.ammedPhoneDialog = false;
                        this.verifyPhoneForm.code = '';
                        // this.postReceiptInfo();
                        this.getMine()
                    });
                }
            });
        },
        cancel() {
            // console.log('取消了')
            this.ammedPhoneDialog = false
            this.verifyPhoneType = 'phone'
        }
  	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.main
	.list
		margin-bottom:40px;
		.l-title
			height:30px;
			font-size:16px;
			font-weight:400;
			color:rgba(152,157,171,1);
			line-height:30px;
			letter-spacing:1px;
			margin-bottom:13px;
		.l-list
			display:flex;
			align-items:center;
			.l-img
				width:80px;
				height:80px;
				border-radius:50px;
				cursor :pointer;
			.l-img-btn
				height:42px;
				padding:0 30px;
				text-align:center;
				background:rgba(39,81,203,1);
				border-radius:24px;
				font-size:14px;
				font-weight:500;
				color:rgba(255,255,255,1);
				line-height:42px;
				margin-left:28px;
				cursor :pointer;
			.l-input
				width:368px;
			.l-pass-btn
				height:42px;
				padding:0 30px;
				text-align:center;
				background:rgba(55,65,93,1);
				border-radius:24px;
				font-size:14px;
				font-weight:500;
				color:rgba(255,255,255,1);
				line-height:42px;
				margin-left:28px;
				cursor :pointer;
	.wrap
		padding 50px 0
		border-bottom 1px solid #e7e7e7
</style>
<style lang="stylus">
.user-icon-model
	.ivu-modal
		height 400px
		.ivu-modal-content
			.ivu-modal-close
				font-size 20px
				color #fff
				right -25px
				top -5px
				.ivu-icon, .ivu-icon-ios-close-empty
					color #fff
			.ivu-modal-body
				height 300px
				padding 40px 50px

</style>
<style  lang="stylus">
.set_pw_modal
    
    .ivu-modal
        .ivu-modal-content
            padding 15px 30px 
            .ivu-modal-body
                .modal_title
                    margin-bottom 20px
            .ivu-modal-close
                font-size 20px
                color #fff
                right -25px
                top -5px
                .ivu-icon, .ivu-icon-ios-close-empty
                    color #fff
            .ivu-modal-footer
                padding-bottom:0px;
                padding:0px;
</style>


// WEBPACK FOOTER //
// src/components/personalSetter/accountSet.vue